import ContentBlockMixin from '@shared/mixins/ContentBlock';
import APIUpload from '@shared/services/API/Upload';

export const getUploadMixin = (key = null, dataKey = null) => {
  const finalKey = key || 'local';

  return {
    mixins: [ContentBlockMixin],
    data: () => ({
      [finalKey]: {
        file: null,
        progressValue: null,
        progressTotal: null,
      },
    }),
    computed: {
      [`${key ? `${key}FileSize` : 'localFileSize'}`]() {
        if (this[finalKey].file) {
          return Math.round((this[finalKey].file.size / (1024 * 1024)) * 100) / 100;
        }

        return null;
      },
      [`${key ? `${key}Path` : 'localPath'}`]() {
        const path = this.newData[dataKey || 'path'].startsWith('http')
          ? this.newData[dataKey || 'path']
          : `${this.$env.apiResourcesURL}/${this.data[dataKey || 'path']}`;

        return path;
      },
    },
    methods: {
      [`${key ? `${key}OnCancel` : 'onCancel'}`]() {
        if (this[`${key ? `${key}UploadPromise` : 'uploadPromise'}`]) {
          this[`${key ? `${key}UploadPromise` : 'uploadPromise'}`].cancel();
          this[`${key ? `${key}UploadPromise` : 'uploadPromise'}`] = null;
        }
      },
      [`${key ? `${key}UploadFile` : 'uploadFile'}`](store, type, onDone) {
        const params = {
          type,
          file: this[finalKey].file,
          fileableId: this.trainingItem.id,
          fileableType: 'TRAINING_ITEM',
        };

        const onUploadProgress = (event) => {
          this[finalKey].progressValue = event.loaded;
          this[finalKey].progressTotal = event.total;
        };

        this.saveIsDisabled = true;
        this[`${key ? `${key}UploadPromise` : 'uploadPromise'}`] = APIUpload.upload(params, onUploadProgress)
          .then((file) => {
            const { url } = file;

            if (onDone) {
              return onDone(url);
            }

            this.newData[dataKey || 'path'] = url;
            return url;
          })
          .finally(() => {
            this.saveIsDisabled = false;
            this[finalKey].file = null;
            this[finalKey].progressValue = null;
            this[finalKey].progressTotal = null;
          });

        return this[`${key ? `${key}UploadPromise` : 'uploadPromise'}`];
      },
    },
  };
};

export default getUploadMixin();
